.page { flex: 1; overflow-y: auto; padding: 24px 28px 48px; }
.header { margin-bottom: 24px; }
.header h1 { display: flex; align-items: center; gap: 8px; margin: 0 0 4px; }
.header p { margin: 0; max-width: 640px; }

.center {
  flex: 1; align-self: stretch;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 12px; padding: 48px; color: var(--text-muted); text-align: center;
}
.center h2 { margin: 0; color: var(--text-primary); }
.center p { margin: 0; max-width: 460px; }
.spin { animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0); } to { transform: rotate(360deg); } }

.group { margin-bottom: 28px; }
.groupTitle {
  font-size: var(--fs-md);
  color: var(--text-secondary);
  text-transform: uppercase; letter-spacing: 0.08em;
  margin: 0 0 12px;
}

.list { display: flex; flex-direction: column; gap: 10px; }

.card {
  display: grid;
  grid-template-columns: 88px 48px 1fr auto;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  transition: border-color var(--dur-fast) var(--ease), transform var(--dur-fast) var(--ease);
}
.card:hover { border-color: var(--border-strong); }
.cardOn { border-color: var(--accent); background: linear-gradient(180deg, var(--accent-soft), var(--bg-elevated) 50%); }

.cardTime {
  display: flex; flex-direction: column; align-items: flex-start;
  font-variant-numeric: tabular-nums;
}
.cardTime strong { font-size: var(--fs-lg); }
.cardTime span { font-size: var(--fs-xs); color: var(--text-muted); }

.cardLogo {
  width: 48px; height: 48px; border-radius: var(--r-sm);
  background: var(--bg-elevated-2);
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
}
.cardLogo img { width: 100%; height: 100%; object-fit: contain; }
.cardLogo span { font-weight: 600; color: var(--text-muted); font-size: var(--fs-sm); }

.cardBody { min-width: 0; }
.cardChannel { font-size: var(--fs-xs); color: var(--text-muted); }
.cardTitle {
  font-weight: 600; font-size: var(--fs-md);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.cardDesc {
  margin-top: 2px;
  font-size: var(--fs-sm); color: var(--text-secondary);
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}

.cardActions { display: flex; align-items: center; gap: 6px; }
.removeBtn {
  width: 32px; height: 32px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 50%;
  color: var(--text-muted);
}
.removeBtn:hover { background: var(--bg-elevated-2); color: var(--danger); }
